<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="users"
      resource="admin-users"
    >
      <!--<el-table-column
        prop="id"
        label="ID"
        align="center"
        show-overflow-tooltip
        min-width="2%"
      />-->
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
      <el-table-column
        prop="account"
        label="账号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="phone"
        label="手机号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="job_number"
        label="工号"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
      <el-table-column
        prop="area"
        label="区域"
        align="center"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="{ row }">
          <el-tag
            class="mr-1"
            v-show="row.quanbu"
          >
            全部
          </el-tag>
          <el-tag
            v-for="i of row.areas"
            :key="i.id"
            class="mr-1"
          >
            {{ i.name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="角色"
        align="center"
        show-overflow-tooltip
        min-width="110"
      >
        <template #default="{ row }">
          <el-tag
            v-for="i of row.roles"
            :key="i.id"
            class="mr-1"
          >
            {{ i.name }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="状态"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status"
            type="success"
          >正常</el-tag>
          <el-tag
            v-else
            type="danger"
          >禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="能否登录运维端"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_login_app"
            type="success"
          >正常</el-tag>
          <el-tag
            v-else
            type="danger"
          >禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="添加时间"
        align="center"
        show-overflow-tooltip
       min-width="120"

      />
      <el-table-column
        prop="updated_at"
        label="修改时间"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        label="操作"
        align="center"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <row-destroy />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getAdminUsers } from "@/api/admin-users";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          field: "id",
          label: "ID"
        },
        {
          field: "name",
          label: "姓名"
        },
        {
          field: "account",
          label: "账号"
        },
        {
          field: "role_name",
          label: "角色"
        },
        {
          field: "phone",
          label: "手机号"
        },
        {
          field: "job_number",
          label: "工号"
        }
      ],
      users: [],
      page: null,
      first_blood: true
      // is_administrator:false,
    };
  },
  mixins: [mixinsAutoPageSize],
  async created() {
 
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
         if (env.isPosSwitch == true) {
      this.search.push({
        type: "el-select",
        field: "merchant_id",
        label: "商户",
        options: [
          {
            id: "",
            name: "全部"
          }
        ]
      });
      this.search[6].options.push.apply(this.search[6].options, merchant.data);

    }
    }
  },
  watch: {

    $route: {
      async handler(newVal) {
        console.log(newVal,'guanchaqi');
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getAdminUsers(newVal.query);
        console.log(data,'数据12121');

        this.users = data;
        this.page = meta;

      },
      immediate: true
    }
  }
};
</script>
